import { createSlice } from "@reduxjs/toolkit";
import { getUsers, getSPUsers } from "./thunk";

export interface IState {
  users: any;
  isUserLoading: boolean;
  isUserSuccess: boolean;

  spUsers: any,
  isSPUserLoading: boolean,
  isSPUserSuccess: boolean,

  error: any;
}

export const initialState: IState = {
  users: null,
  isUserLoading: false,
  isUserSuccess: false,

  spUsers: null,
  isSPUserLoading: false,
  isSPUserSuccess: false,

  error: {},
};

const UserSlice = createSlice({
  name: "User",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Users
    builder.addCase(getUsers.pending, (state: IState, action: any) => {
      state.isUserLoading = true;
    });
    builder.addCase(getUsers.fulfilled, (state: IState, action: any) => {
      state.users = action.payload.data;
      state.isUserSuccess = true;
      state.isUserLoading = false;
    });
    builder.addCase(getUsers.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isUserSuccess = false;
      state.isUserLoading = false;
    });

    //get SP Users
    builder.addCase(getSPUsers.pending, (state: IState, action: any) => {
      state.isSPUserLoading = true;
    });
    builder.addCase(getSPUsers.fulfilled, (state: IState, action: any) => {
      state.spUsers = action.payload.data;
      state.isSPUserSuccess = true;
      state.isSPUserLoading = false;
    });
    builder.addCase(getSPUsers.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isSPUserSuccess = false;
      state.isSPUserLoading = false;
    });
  },
});

export default UserSlice.reducer;
